import { COLORS } from '~theme/colors'

export const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024 // 20 MB
export const MAX_FILE_SIZE_LABEL = '20 MB'

export const sectionBoxSx = {
  border: '1px solid',
  borderColor: COLORS.greys.light,
  borderRadius: 1,
  p: 2,
  mb: 3,
}

export const fieldsContainerSx = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 3,
  mt: 3,
}

export const remarksGridSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, 1fr)',
    md: 'repeat(3, 1fr)',
  },
  gap: 3,
  mt: 3,
}

export const fileItemContainerSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  minWidth: 0,
  overflow: 'hidden',
  px: 0.5,
  py: 0.25,
  borderRadius: 0.5,
  '&:hover': {
    backgroundColor: COLORS.secondary.blueTint,
    '& .file-delete-button': {
      visibility: 'visible',
    },
  },
} as const

export const fileLinkSx = {
  color: COLORS.secondary.midBlue,
  textDecoration: 'none',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block',
  fontSize: '0.9rem',
  lineHeight: '1rem',
  '&:hover': {
    textDecoration: 'underline',
  },
} as const

export const fileDeleteButtonSx = {
  p: 0.25,
  color: COLORS.red.dark,
  visibility: 'hidden',
  '&:hover': {
    backgroundColor: 'transparent',
  },
} as const
